import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Home";
import Trading from "./components/Trading"
// import Header from "./components/Header";
import Login from "./Login";
import Signup from "./Signup";
import TermsConditions from "./components/TermsConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import WhyTredixo from "./components/WhyTredixo";
import Campaign from "./components/Campaign";

function GTMRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "page_view",
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <GTMRouteTracker />
      <Routes>
        {/* Home Page */}
        <Route path="/" element={<Home/>} />

        {/* Auth Pages */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup/>} />
        <Route path="/trading" element={<Trading/>} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/why-tredixo" element={<WhyTredixo />} />
        
        {/* Dynamic Campaign Page */}
        <Route path="/campaign/:influencerName" element={<Campaign />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
